import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  standalone: true
})
export class AccessDeniedComponent {
  contactInfo = {
    email: 'soporte@apser.es'
  };

  constructor(private authService: AuthService, private userService: UserService, private router: Router,
  ) { }

  logOut() {
    this.authService.logout();
  }

  login() {
    this.userService.removeUser();
    this.authService.login();
  }
}
